import { useEffect, useState } from 'react';
import { adminApi } from '@formosa/shared/api/admin';

const DEFAULT_GOOGLE_CONFIG = {
  skip: false,
  allowBypassCode: false,
  requireOnLogin: true,
};

/**
 * 讀取後台谷歌驗證 Nacos 配置（登入／敏感操作用）。
 */
export function useGoogleVerifyConfig() {
  const [config, setConfig] = useState(DEFAULT_GOOGLE_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    adminApi
      .googleVerifyConfig()
      .then((data) => {
        if (!cancelled && data) {
          setConfig({
            skip: Boolean(data.skip),
            allowBypassCode: Boolean(data.allowBypassCode),
            requireOnLogin: Boolean(data.requireOnLogin),
          });
        }
      })
      .catch(() => {
        if (!cancelled) {
          setConfig(DEFAULT_GOOGLE_CONFIG);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { config, loading };
}

/** 是否需在 UI 顯示谷歌驗證碼欄位（登入頁） */
export function shouldShowLoginGoogleField(config) {
  return Boolean(config?.requireOnLogin);
}

/** 是否需在 UI 顯示並必填谷歌驗證碼（敏感操作） */
export function shouldRequireOperationGoogleField(config) {
  if (config?.skip) {
    return false;
  }
  return true;
}

/** 提交前校驗谷歌驗證碼（skip 時不校驗） */
export function validateGoogleCodeInput(config, googleCode, { lenientWhenSkip = false } = {}) {
  if (config?.skip) {
    if (lenientWhenSkip) {
      return '';
    }
    return '';
  }
  const code = googleCode?.trim() || '';
  if (config?.allowBypassCode && code === '123456') {
    return '';
  }
  if (!code) {
    return '請輸入谷歌驗證碼';
  }
  return '';
}
